import { defineStore } from "pinia";
import axios from "axios";

export const useAuthStore = defineStore("DRIVER-AUTH", {
  state: () => ({
    token: null, // JWT Token
  }),
  actions: {
    setToken(token) {
      this.token = token;
      console.log("auth.js 获取到JWT Token: " + token);
      axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    },
    removeToken() {
      this.token = null;
      delete axios.defaults.headers.common["Authorization"];
    },
    // async login(username, password) {
    //   try {
    //     const response = await axios.post("https://delivery-api.xiaohuangxi.studio/api/merchant/login", {
    //       username,
    //       password,
    //     });
    //     if (response.data.code == 1) {
    //       this.setToken(response.data.token);
    //       return response.data;
    //     } else {
    //       throw new Error(response.data.message || "登录失败");
    //     }
    //   } catch (error) {
    //     console.log("Auth.js报错："+error)
    //     throw new Error(error.msg?.data?.message || "网络错误");
    //   }
    // },
    logout() {
      this.removeToken(); // 清除 token
      this.userInfo = null; // 清空用户信息
      localStorage.removeItem("DRIVER-AUTH");
    },
  },
  persist: {
    key: "DRIVER-AUTH", // localStorage 键名
    storage: localStorage, // 持久化到 localStorage
  },
});
